import { defineMessages } from 'react-intl';

export default defineMessages({
    noUserFound: {
        id: 'agency.admin.views.messages.noUserFound',
        defaultMessage: 'No user with matching email address found'
    },
    EmailValidationMessage: {
        id: 'twia.agencyUser.views.Must be a valid email address',
        defaultMessage: 'Must be a valid email address',
    },
    // Added Validation messages for ZipCode field
    ZipCodeValidationMessage: {
        id: 'twia.agencyUser.views.Value must be a valid postal code.',
        defaultMessage: 'Value must be a valid postal code.',
    },
    ZipCodeValidationRequiredMessage: {
        id: 'twia.agencyUser.views.This is a required field.',
        defaultMessage: 'This is a required field.',
    },
});